import type { SagaIterator } from 'redux-saga';
import { all, call, fork, race, take } from 'redux-saga/effects';
import { CANCEL, OK, SHOW_CONFIRM } from './action-types.js';
import type { ShowConfirm } from './actions.js';

export function* waitForConfirm(): SagaIterator {
  const { ok } = yield race({
    ok: take(OK),
    cancel: take(CANCEL)
  });
  return Boolean(ok);
}

export function* handleConfirm(): SagaIterator {
  while (true) {
    const { payload }: ReturnType<ShowConfirm> = yield take(SHOW_CONFIRM);

    const ok = yield call(waitForConfirm);

    if (payload && (payload.callback || payload.onConfirm || payload.onCancel)) {
      setTimeout(() => {
        const wasConfirmed = Boolean(ok);
        if (payload.callback) {
          payload.callback(wasConfirmed);
        }

        if (wasConfirmed && payload.onConfirm) {
          payload.onConfirm();
        }

        if (!wasConfirmed && payload.onCancel) {
          payload.onCancel();
        }
      }, 0);
    }
  }
}

export default function* root() {
  yield all([fork(handleConfirm)]);
}
